import { Check, SlidersHorizontal } from 'lucide-react';
import { useEffect, useState } from 'react';
import { dateRangeForPreset } from '../../shared/listFilters';
import { Button } from './button';
import { DateRangeInputs } from './time-range';
import { SegmentedControl } from './segmented-control';

export function ListDateFilters({
  range,
  from,
  to,
  onChange,
  startId,
  endId,
}: {
  readonly range: string;
  readonly from: string;
  readonly to: string;
  readonly onChange: (patch: Record<string, string>) => void;
  readonly startId: string;
  readonly endId: string;
}) {
  const [showCustomDates, setShowCustomDates] = useState(false);
  const [draftFrom, setDraftFrom] = useState(from);
  const [draftTo, setDraftTo] = useState(to);
  const hasDraftChanges = draftFrom !== from || draftTo !== to || range !== 'custom';
  const hasInvalidDraftRange = Boolean(draftFrom && draftTo && new Date(draftFrom).getTime() > new Date(draftTo).getTime());

  useEffect(() => {
    setDraftFrom(from);
    setDraftTo(to);
  }, [from, to]);

  const setToday = () => {
    onChange({ range: 'today', ...dateRangeForPreset('today') });
  };
  const setWeek = () => onChange({ range: 'week', ...dateRangeForPreset('week') });
  const setMonth = () => onChange({ range: 'month', ...dateRangeForPreset('month') });
  const applyCustomDates = () => {
    if (hasInvalidDraftRange) return;
    onChange({ range: 'custom', from: draftFrom, to: draftTo });
  };

  return (
    <div className="grid gap-3">
      <div className="flex flex-wrap gap-2">
        <SegmentedControl
          value={range as 'today' | 'week' | 'month'}
          options={[{ id: 'today', label: 'Hoy' }, { id: 'week', label: 'Semana' }, { id: 'month', label: 'Mes' }]}
          onChange={(nextRange) => nextRange === 'today' ? setToday() : nextRange === 'week' ? setWeek() : setMonth()}
          ariaLabel="Periodo de la lista"
        />
        <Button type="button" variant={showCustomDates ? 'primary' : 'secondary'} onClick={() => setShowCustomDates((current) => !current)}>
          <SlidersHorizontal className="h-4 w-4" aria-hidden="true" />
          Fechas
        </Button>
      </div>
      {showCustomDates ? (
        <DateRangeInputs
          start={{ id: startId, value: draftFrom, onChange: (event) => setDraftFrom(event.target.value) }}
          end={{ id: endId, value: draftTo, onChange: (event) => setDraftTo(event.target.value) }}
          startLabel="Fecha inicial"
          endLabel="Fecha final"
          allowEqual
        >
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-xs text-[#687461]">El rango se actualiza hasta aplicar los cambios.</p>
            <Button type="button" disabled={!hasDraftChanges || hasInvalidDraftRange} onClick={applyCustomDates}>
              <Check className="h-4 w-4" aria-hidden="true" />
              Aplicar fechas
            </Button>
          </div>
        </DateRangeInputs>
      ) : null}
    </div>
  );
}
